module.exports = __webpack_public_path__ + "fd58665acb03657dfb9a38420e672177.png";